export default {
  methods: {
    toDate(utcString) {
      if (utcString === '' || utcString === null) {
        return '';
      }
      let date = new Date(utcString);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    },

    toddmmyyyy(date) {
      const newDate = new Date(date);
      return this.$d(newDate);
    },

    toValidPhpDate(date) {
      const newDate = new Date(date);
      return `${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()}`;
    },
  }
};
